import { createCommunityAuthContext } from './createCommunityAuthContext';

const { Provider: SharkAuthProvider, useAuth: useSharkAuth } = createCommunityAuthContext({
  community: 'shark',
});

export { SharkAuthProvider, useSharkAuth };
